import Enumerable from "linq";
import { Directory } from "../../../../../../base/domain/drawing";
import {
  EditableFormatSummary,
  IEditableFormatSummaryTreeNode,
  IEditableFormatSummaryTreeData,
} from "../../../../../domain/editableFormat";

export interface IExpandableTreeNodeIconClasses {
  normal: string;
  expanded: string;
}

export interface IFormatTreeNodeIconClasses {
  directory: IExpandableTreeNodeIconClasses;
  format: string;
}

export class FormatTreeNodeUtility {
  static defaultIconClasses: IFormatTreeNodeIconClasses = {
    directory: {
      normal: "tree-icon-directory",
      expanded: "tree-icon-directory-expand",
    },
    format: "tree-icon-format",
  };

  constructor(iconClasses?: IFormatTreeNodeIconClasses) {
    this._iconClasses = !iconClasses
      ? FormatTreeNodeUtility.defaultIconClasses
      : iconClasses;
  }

  private readonly _iconClasses: IFormatTreeNodeIconClasses;

  findNode(node: IEditableFormatSummaryTreeNode, predicate: (n: IEditableFormatSummaryTreeNode) => boolean): IEditableFormatSummaryTreeNode {
    return predicate(node)
      ? node
      : Enumerable.from(node.childNodes).select(n => this.findNode(n, predicate)).firstOrDefault(n => !!n);
  }

  toFormatNode(entity: EditableFormatSummary, index: number): IEditableFormatSummaryTreeData {
    return {
      id: index,
      label: entity.name,
      iconClass: this._iconClasses.format,
      source: entity,
      children: [],
    };
  }

  expandNode(node: IEditableFormatSummaryTreeNode, key?: number): void {
    this.expandNodeExecution(node, key);
  }

  private expandNodeExecution(node: IEditableFormatSummaryTreeNode, key?: number): boolean {
    if (node.data instanceof Object && node.data.source instanceof Directory) {
      if (typeof key !== "number") {
        this.setExpandProperty(node);
      } else if (node.data.source.key === key) {
        this.setExpandProperty(node);
        return true;
      }
    }
    if (node.childNodes instanceof Array) {
      for (const t of node.childNodes) {
        if (this.expandNodeExecution(t, key)) {
          return true;
        }
      }
    }
    return false;
  }

  private setExpandProperty(node: IEditableFormatSummaryTreeNode): void {
    if (node === null) {
      return;
    }
    if (node.childNodes instanceof Array && node.childNodes.length > 0) {
      node.expanded = true;
      node.data.iconClass = this._iconClasses.directory.expanded;
    }
    this.setExpandProperty(node.parent);
  }

  updateNodeExpanded(node: IEditableFormatSummaryTreeData, nodeProperty: IEditableFormatSummaryTreeNode, nodeSelf: any): void {
    if (nodeProperty.data.source instanceof Directory) {
      node.iconClass = nodeSelf.expanded
        ? this._iconClasses.directory.normal
        : this._iconClasses.directory.expanded;
    }
  }

  nodeIconClass(node: IEditableFormatSummaryTreeNode): string {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory) {
        return node.expanded
          ? this._iconClasses.directory.expanded
          : this._iconClasses.directory.normal;
      }
      return this._iconClasses.format;
    }
    return "";
  }
}
